import type { CurrencyAmountDto } from "@hisense/shared";
import { formatMoney, majorUnits } from "@/domain/money";

/**
 * Nhiều số tiền, mỗi tiền tệ một dòng, KHÔNG cộng lại (yêu cầu v1.8 mục 2.4): "USD 1,000.00" rồi "RMB 7,000.00" ngay dưới.
 *
 * Mã tiền tệ đứng trước số thay vì ký hiệu: ¥ là cả CNY lẫn JPY, còn "$" không nói được là USD hay HKD khi hai dòng đứng cạnh nhau.
 * Rỗng (khách chưa có PI nào) thì hiện gạch ngang — không có công nợ ở tiền tệ nào, đừng bịa ra "$0.00 USD".
 */
export function CurrencyAmountList({ items, className = "" }: { items: readonly CurrencyAmountDto[]; className?: string }) {
  if (items.length === 0) return <span className="text-ink-faint">—</span>;
  return (
    <div className={`flex flex-col gap-0.5 font-mono tabular ${className}`}>
      {items.map((x) => (
        <span key={x.currency} className="whitespace-nowrap">
          <span className="text-2xs text-ink-soft">{x.currency}</span>{" "}
          <span className="font-medium text-ink">{formatMoney(x.amount, x.currency, { symbol: false })}</span>
        </span>
      ))}
    </div>
  );
}

/** Bản chữ cho tệp xuất: "USD 1000.00 | RMB 7000.00" — một ô, không cộng hai tiền tệ. */
export function currencyAmountsText(items: readonly CurrencyAmountDto[]): string {
  return items.map((x) => `${x.currency} ${majorUnits(x.amount)}`).join(" | ");
}
